// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"228":"345ddba4","408":"0bb14a4c","642":"c09c42bb"}[chunkId] + ".chunk.js");